@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

$planned-bg-color: #ffd387;
$planned-font-color: #474747;

.status {
  border-radius: 24px;
  text-align: center;
  @include t.text(12px, 20px, 500);
  padding: 2px 10px;
  color: v.$palette-accent;
  background-color: v.$palette-gray-200;
}
